import React from 'react';
import { Button, Dialog, DialogContent, DialogTitle } from '@material-ui/core';
import { isMobile } from 'react-device-detect';
const DeletePopUp = ({ modal, title, content, toggleModalFn, deleteRecordFn, confirmText, cancelText, cancelColor, confirmColor ,extraNote}) => {
	return (
		<Dialog
			open={modal}
			onClose={toggleModalFn}
			aria-labelledby="scroll-dialog-title"
			maxWidth='sm'
			className="delete-record-modal"
		>
			<DialogTitle id="scroll-dialog-title">
				{title ? title : 'Delete'}
			</DialogTitle>
			<DialogContent dividers={true}>
				<div style={isMobile ? { width: 'auto' } : { minWidth: '400px' }}>
					<div className="">
						{content}
					</div>
					<div className="actions-cta">
						<Button variant="outlined" size='small' onClick={toggleModalFn} color={cancelColor ? cancelColor : 'primary'}>{cancelText ? cancelText : 'Cancel'}</Button>
						<Button variant="contained" size='small'  onClick={deleteRecordFn} color={confirmColor ? confirmColor : "secondary"}>{confirmText ? confirmText : 'Delete'}</Button>
					</div>
					{extraNote ?<p style={{margin:'10px 0px'}}>
                        <span style={{fontWeight:"800px"}}>Attention:</span> <span style={{background:'#f9f96f'}}>Data associated with the same part number will be deleted in the LLP status.</span>
                    </p> : null}
				</div>
			</DialogContent>
		</Dialog>
	)
}
export default DeletePopUp;
